import React from 'react';
import { User, Mail, Phone } from 'lucide-react';

const CandidatoList = ({ candidatos, onCandidatoClick }) => {
  return (
    <div className="mt-4 px-4">
      <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="p-3 text-xs font-bold text-gray-500 uppercase">Candidato</th>
              <th className="p-3 text-xs font-bold text-gray-500 uppercase">Contacto</th>
              <th className="p-3 text-xs font-bold text-gray-500 uppercase">Etapa Actual</th>
              <th className="p-3 text-xs font-bold text-gray-500 uppercase">Documentos</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {candidatos.length === 0 ? (
              <tr><td colSpan="4" className="text-center p-8 text-gray-400">No hay candidatos en este proceso</td></tr>
            ) : (
              candidatos.map((candidato) => (
                <tr 
                  key={candidato.id} 
                  onClick={() => onCandidatoClick(candidato)}
                  className="hover:bg-green-50 cursor-pointer transition-colors"
                >
                  <td className="p-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-emeral-green bg-opacity-20 flex items-center justify-center shrink-0">
                        {candidato.foto_url ? (
                          <img src={candidato.foto_url} alt="" className="w-full h-full rounded-full object-cover" />
                        ) : (
                          <User size={20} className="text-emeral-green" />
                        )}
                      </div>
                      <span className="font-bold text-sm text-gray-700">{candidato.nombre}</span>
                    </div>
                  </td>
                  <td className="p-3">
                    <div className="text-xs text-gray-500 flex flex-col gap-1">
                      <span className="flex items-center gap-1"><Mail size={12}/> {candidato.email}</span>
                      {candidato.telefono && <span className="flex items-center gap-1"><Phone size={12}/> {candidato.telefono}</span>}
                    </div>
                  </td>
                  <td className="p-3">
                    <span className="text-xs font-bold text-emeral-green uppercase bg-emeral-green bg-opacity-10 px-2 py-1 rounded">
                      {candidato.etapa_actual}
                    </span>
                  </td>
                  <td className="p-3">
                    {candidato.cv_url ? (
                      <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded font-medium border">CV PDF</span>
                    ) : (
                      <span className="text-xs text-gray-300">-</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CandidatoList;
